import * as React from 'react';
import classNames from 'classnames';
import { SortOption } from '../mill-products-list-page';
import { IMillProductsListPageResources } from '../mill-products-list-page.props.autogenerated';

export interface IMilSortByDropdownProps {
    options: SortOption[];
    selectedSort?: string;
    onSortChange?: (sortId: string) => void;
    resources: IMillProductsListPageResources;
    id?: string;
    className?: string;
}

const MilSortByDropdown: React.FC<IMilSortByDropdownProps> = ({
    options = [],
    selectedSort = '',
    onSortChange,
    resources,
    id = 'ms-sort-by-select',
    className
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onSortChange?.(e.target.value);
    };

    return (
        <div className={classNames('ms-sort-by-dropdown-wrapper', className)}>
            <label htmlFor={id} className='ms-sort-by-label'>
                {resources.sortByDropdownLabel}
            </label>

            <select
                id={id}
                className='ms-sort-by-dropdown'
                value={selectedSort}
                onChange={handleChange}
                aria-label={resources.sortByDropdownLabel}
            >
                {options.map(opt => {
                    const text = resources[opt.resourceKey] || opt.resourceKey || opt.id;
                    return (
                        <option key={opt.id} value={opt.id} className='active-option'>
                            {text}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default MilSortByDropdown;
